import { h } from "../kit/dom.ts";
import { simpatiaChips } from "../panels/trade-model.ts";

/** Simpatias do jogador (doc 05, HUD): uma etiqueta por Simpatia, com as pilhas e o efeito no título. */
export class SimpatiasHud {
  /** As etiquetas (`#simpatias`): desde a F109, na coluna da esquerda do HUD, sob o cartão do jogador. */
  readonly element: HTMLElement;
  private key = "";

  constructor(parent: HTMLElement) {
    this.element = h("div", { id: "simpatias", "aria-label": "Bênçãos" });
    parent.appendChild(this.element);
  }

  update(counts: Iterable<[string, number]> | undefined): void {
    const chips = simpatiaChips(counts ?? []);
    const key = chips.map((c) => c.text).join("|");
    if (key === this.key) return;
    this.key = key;
    this.element.replaceChildren(...chips.map((c) => h("span", { class: `simpatia ${c.rarity}`, title: c.title, "data-id": c.id }, c.text)));
  }

  remove(): void {
    this.element.remove();
  }
}
